export default (value, length = 100) => value.length <= length ? value : value.substring(0, length) + '...'
